<div *ngIf="loading" class="text-center py-5">
    <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
        <p style="color: white">Please Wait...</p>
    </ngx-spinner>
</div>

<div class="header_second col-12">
    <div class="Dashboard_head">{{ so_id ? 'My Catalogue/Shop' : 'Create Your Catalogue/Shop'}}
        <div *ngIf="so_id" class="header-actions">
            <!-- MANAGE USERS -->
            <button mat-raised-button style="margin-right: 10px; background:#e0f2f1; color:#00695c;" (click)="openStallUsers(so_id)">
                <mat-icon>group</mat-icon> Users
            </button>

            <!-- COPY BUTTON -->
            <button mat-raised-button color="accent" style="margin-right: 10px;" (click)="copyLink(so_id)">
                COPY<mat-icon>content_copy</mat-icon>
            </button>

            <!-- SHARE / OPEN LINK -->
            <button mat-raised-button color="primary" style="margin-right: 10px;" (click)="openLink(so_id)">
                <mat-icon class="m-0">share</mat-icon>
            </button>
        </div>
    </div>
</div>


<!-- IF no so_id → show CREATE form -->
<div *ngIf="!loading && !so_id" class="container mt-3">

    <form [formGroup]="StallForm" (ngSubmit)="onFormSubmit()">
        <!-- IMAGE UPLOAD + PREVIEW -->
        <div class="row mb-4">
            <div class="col-md-9">
                <label class="form-label fw-semibold">Select Image</label>
                <input type="file" class="form-control" #file accept="image/*" (change)="previewpimage(file.files)" />
            </div>

            <div class="col-md-3 text-center">
                <img *ngIf="!isOld1 && imagePath" [src]="'https://aieventzo.com/upload/0/stall/' + imagePath"
                    class="preview-img" />

                <img *ngIf="isOld1 && image_name" [src]="'https://aieventzo.com/upload/0/stall/' + image_name"
                    class="preview-img" />
            </div>
        </div>

        <!-- FORM FIELDS -->
        <div class="row">
            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Owner Name</mat-label>
                    <input matInput formControlName="owner_name" placeholder="Enter owner name" />
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Owner Number</mat-label>
                    <input matInput type="number" maxlength="10" [ngModel]="owner_number" formControlName="owner_number"
                        [readonly]="true" />
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Email</mat-label>
                    <input matInput formControlName="email" placeholder="Enter email" />
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Company Name</mat-label>
                    <input matInput formControlName="company_name" placeholder="Enter company name" />
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Address</mat-label>
                    <input matInput formControlName="address" placeholder="Enter address" />
                    <mat-hint align="end">
                        {{ StallForm.get('address')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Website</mat-label>
                    <input matInput formControlName="website" placeholder="https://"/>
                    <mat-hint align="end">
                        {{ StallForm.get('website')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Youtube</mat-label>
                    <input matInput formControlName="youtube" placeholder="YouTube link" />
                    <mat-hint align="end">
                        {{ StallForm.get('youtube')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Facebook</mat-label>
                    <input matInput formControlName="facebook" placeholder="Facebook link" />
                    <mat-hint align="end">
                        {{ StallForm.get('facebook')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="col-md-6 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Instagram</mat-label>
                    <input matInput formControlName="instagram" placeholder="Instagram link" />
                    <mat-hint align="end">
                        {{ StallForm.get('instagram')?.value?.length || 0 }}/250
                    </mat-hint>
                </mat-form-field>
            </div>

            <div class="col-md-12 mb-3">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Notes</mat-label>
                    <input matInput formControlName="notes" placeholder="Write something about your shop..." />
                </mat-form-field>
            </div>
        </div>

        <!-- ACTION BUTTONS -->
        <div class="d-flex justify-content-end mt-3 gap-2">
            <button mat-raised-button color="primary" type="submit">Create Shop</button>
        </div>
    </form>
</div>

<!-- IF so_id present → show EDIT STALL -->
<div *ngIf="!loading && so_id" class="container mt-3">
    <app-edit-stall [so_id]="so_id"></app-edit-stall>
</div>